export const publicDishPdfTexts = {
  climate: {
    title: 'Klimat',
    issueTextParagraphs: [
      'Enligt IPCC kommer ungefär en tredjedel av alla utsläpp av växthusgas som uppstår av mänsklig aktivitet från vår produktion, transport, tillredning, konsumtion och försäljning av mat.',
      'Klimatvärdet beräknas av Consupedia utifrån data från RISE som visar olika livsmedels utsläpp av växthusgaser (CO2e). Poängen visar vilken klimatpåverkan produkten har jämfört med andra livsmedelsprodukter i databasen. Om en produkt innehåller flera ingredienser baseras poängen på produktens totala utsläpp.',
    ],
    howToThinkTextParagraphs: [
      'Klimatvärdet inkluderar produktens klimatpåverkan inklusive förpackning fram till och med råvarans eventuella förädling i industri. Transport från industri, via eventuell grossist, och till organisation som ska tillaga måltiden är alltså inte inkluderad. Undantag är gjorda för importerade produkter där ett klimatbidrag för en generellt antagen transport till Sverige är ingår i beräkningen.',
    ],
    fourthtext: [''],
    sources: [
      {
        name: 'RISE klimatdatabas',
        url: 'https://www.ri.se/sv/vad-vi-gor/expertiser/rise-klimatdatabas-for-livsmedel',
      },
      {
        name: 'IPCC, 2014: Climate Change 2014: Synthesis Report',
        url: 'https://www.ipcc.ch/report/ar5/syr/',
      },
    ],
  },
  water: {
    title: 'Vatten',
    issueTextParagraphs: [
      'Vattenfotavtrycket speglar den totala mängd vatten som krävs för att producera ett kilo av livsmedlet. Vi använder oss av Water Footprint Networks beräkningar av vattenfotavtryck som tar hänsyn till tre typer av vatten som krävs för att producera en vara.',
    ],
    howToThinkTextParagraphs: [
      'Skalan 1–100 visar att ju högre värde, desto mindre vatten krävs för att producera produkten.',
    ],
    fourthtext: [''],
    sources: [
      {
        name: 'Water Footprint Network',
        url: 'https://www.waterfootprint.org/',
      },
    ],
  },
  biodiversity: {
    title: 'Biologisk mångfald',
    issueTextParagraphs: [
      'Människans industriella produktion av livsmedel har en skadlig effekt på den biologiska mångfalden. Antalet arter i växt- och djurliv sjunker kraftigt till följd av bekämpningsmedel, växtskyddsmedel, monokulturer, förändring av markområden (t.ex. avskogning), utfiskning och fiskeredskap som förstör havsbotten.',
    ],
    howToThinkTextParagraphs: [
      'EPI (Environmental Performance Index) rankar 180 länder utifrån deras nationella åtgärder för att skydda miljön, stärka ekosystemen och minska klimatförändringar. Rankingen baseras på 40 indikatorer (t.ex. ökade utsläpp av växthusgaser) som är indelade i 11 kategorier (t.ex. klimatförändring). EPI tas årligen fram av de amerikanska universiteten Yale och Columbia tillsammans med den schweiziska stiftelsen World Economic Forum.',
      'Värdet för biologisk mångfald vilar på data från kategorin Biodiversitet och Livsmiljö (Biodiversity & Habitat) i EPI, liksom på RISE databas för biologisk mångfald.',
    ],
    fourthtext: [
      'När du väljer produkter med höga värden, istället för låga, i den här parametern påverkas den biologiska mångfalden i mindre utsträckning. Poängen baseras på ursprungsland för respektive ingrediens/er.',
    ],
    sources: [
      {
        name: 'Environmental Performance Index',
        url: 'https://epi.yale.edu/',
      },
      {
        name: 'RISE databas för biologisk mångfald',
        url: 'https://www.ri.se/sv/expertisomraden/expertiser/biodiversitetsdatabas',
      },
    ],
  },
  transport: {
    title: 'Transport',
    issueTextParagraphs: [
      'Vår mat är en global handelsvara som säljs och transporteras mellan olika delar av världen. Studier visar att transport av ingredienser och livsmedelsprodukter står för nästan en femtedel av alla utsläpp av växthusgas inom matsystemet.',
    ],
    howToThinkTextParagraphs: [
      'Värdet beräknas utifrån hur långt produkten måste transporteras för att nå Sverige. Värdet anges på en hundragradig skala.',
    ],
    fourthtext: [
      'När du väljer produkter med höga värden, istället för låga, i denna kategori kommer din mat ha färdats kortare sträckor för att nå Sverige. Matvaror producerade i Sverige kommer att ha högst poäng.',
    ],
  },
  landUse: {
    title: 'Landanvändning',
    issueTextParagraphs: [
      "Enligt data från FN:s livsmedels- och jordbruksorganisation (FAO) används mer än hälften av jordens beboeliga landyta till jordbruk. I takt med att människan använder mer och mer landyta för matproduktion förlorar andra arter sina naturliga habitat i allt högre utsträckning.",
    ],
    howToThinkTextParagraphs: [
      'Värdet beräknas utifrån data i den vetenskapliga publikationen Poore, J., & Nemecek, T. (2018). Reducing foods environmental impacts through producers and consumers. Beräkningen visar hur stora landområden som krävs för att odla ingrediensen/-erna som ingår i en produkt.',
    ],
    fourthtext: [
      'Höga värden i den här parametern indikerar att mindre landyta har krävts för produktionen av produktens ingredienser, jämfört med andra produkter.',
    ],
  },
  pesticides: {
    title: 'Bekämpningsmedel',
    issueTextParagraphs: [
      'I stora delar av världen används bekämpningsmedel vid odling och matproduktion som är skadliga för människor, djur och natur. Många av de värsta bekämpningsmedlen är förbjudna i Sverige och EU men används fortfarande i länder med matproduktion där lagarna inte är lika stränga.',
    ],
    howToThinkTextParagraphs: [
      "Värdet beräknas utifrån data från FN:s livsmedels- och jordbruksorganisation (FAO). Med stöd av datan rankas länder med avseende på användningen av bekämpningsmedel.",
      'När du väljer produkter med höga värden, istället för låga, i den här parametern bidrar du till lägre användning av bekämpningsmedel.',
      'Poängen baseras ursprungsland för respektive ingrediens-/er.',
    ],
    fourthtext: [''],
    sources: [
      {
        name: 'Food and Agriculture Organization',
        url: 'https://www.fao.org/statistics/en/',
      },
    ],
  },
  fertilizers: {
    title: 'Övergödning',
    issueTextParagraphs: [
      'Konstgödsel spelar en fundamental roll i den globala matproduktionen. Användningen av konstgödsel bidrar till att stora mängder näringsämnen (främst kväve och fosfor) läcker från jordbruk ut i färskvattensystem och hav. Detta bidrar till övergödning vilket orsakar allvarliga skador på miljön.',
    ],
    howToThinkTextParagraphs: [
      "Värdet beräknas utifrån data från FN:s livsmedels- och jordbruksorganisation (FAO). Med stöd av datat rankas länder med avseende på användningen av konstgödsel.",
      'När du väljer produkter med höga värden, istället för låga, i den här parametern är risken för att framställningen av produkten har bidragit till övergödning lägre.',
    ],
    fourthtext: ['Poängen baseras på ursprungsland för respektive ingrediens/er.'],
    sources: [
      {
        name: 'Food and Agriculture Organization',
        url: 'https://www.fao.org/statistics/en/',
      },
    ],
  },
  nutritionalValue: {
    title: 'Hälsa',
    issueTextParagraphs: [
      'Våra matval spelar en avgörande roll för vår hälsa och välbefinnande. En hälsosam kost minskar risken att drabbas av livsstilssjukdomar som t ex obesitas, typ 2-diabetes, hjärt-kärlsjukdom och vissa cancerformer.',
    ],
    howToThinkTextParagraphs: [
      'Värdet för hälsa beräknas utifrån produktens näringsvärden och innehåll, jämfört med andra livsmedelsprodukter i vår databas, baserat på Nutri-score. När du väljer produkter med ett högt värde i kategorin hälsa får du en produkt som till större del består av ingredienser som bidrar till positiva hälsoeffekter och till mindre del består av ingredienser som har visat sig kunna ge negativa hälsoeffekter.',
    ],
    fourthtext: [''],
    sources: [
      {
        name: 'Gender Inequality Index | Human Development Reports',
        url: 'https://hdr.undp.org/data-center/thematic-composite-indices/gender-inequality-index#/indicies/GII',
      },
    ],
  },
  antibiotics: {
    title: 'Antibiotikaresistens',
    issueTextParagraphs: [
      'Antibiotika är läkemedel som används för att behandla bakterieinfektioner både hos människor och djur. Tyvärr kan bakterier utveckla resistens (motståndskraft) mot antibiotika, vilket gör dem mindre effektiva eller till och med overksamma. Ju mer antibiotika som finns i omlopp i miljön, desto större är risken att bakterier utvecklar resistens. En alltför stor användning av antibiotika till livsmedelsproducerande djur kan därför bidra till att bakterieinfektioner hos både människor och djur blir svårare att behandla.',
    ],
    howToThinkTextParagraphs: [
      'Värdet beräknas utifrån data om ursprungslandet för en ingrediens (animalisk) användning av antibiotika vid uppfödning av olika djur för livsmedelsproduktion. Data presenteras årligen från projektet European Surveillance of Veterinary Antimicrobial Consumption (ESVAC), som rankar länder med avseende på användningen av antibiotika. ESVAC drivs av den europeiska läkemedelsmyndigheten European Medicines Agency (EMA). Det är frivilligt för länder att rapportera in data till projektet, som i dag omfattar data från 31 länder.',
      'När du väljer produkter med höga värden, istället för låga, i den här parametern är risken för att framställningen av produkten har bidragit till antibiotikaresistens lägre.',
    ],
    fourthtext: [''],
    sources: [
      {
        name: 'Unicef (Barnkonventionen)',
        url: 'https://unicef.se/barnkonventionen',
      },
      {
        name: 'ILO (International Labor Organization) Data and statistics',
        url: 'https://www.ilo.org/data-and-statistics',
      },
      {
        name: 'ILO (International Labor Organization) Child Labour: Global estimates',
        url: 'https://www.ilo.org/publications/major-publications/child-labour-global-estimates-2020-trends-and-road-forward',
      },
    ],
  },
  socialJustice: {
    title: 'Social rättvisa',
    issueTextParagraphs: [
      'Social rättvisa handlar om i vilken mån människor kan nå sin fulla potential i samhället de lever i. Det kan till exempel gälla tillgång till utbildning, arbete och vård. Ett rättvist samhälle bygger på jämlikhet och ett gemensamt ansvar för alla individers välbefinnande och möjligheter i livet.',
    ],
    howToThinkTextParagraphs: [
      'Värdet beräknas utifrån produktionslandets värde i Bertelsmann-stiftelsens index för social rättvisa (Bertelsmann Stiftung Social Justice Index). Bertelsmann-stiftelsen är en oberoende tysk stiftelse vars syfte bland annat är att främja forskning och vetenskap, kultur och utbildning.',
      'När du väljer produkter med höga värden, istället för låga, i denna kategori bedöms produkten ha framställts i ett land som är mer rättvist än länder med lägre poäng inom denna parameter.',
    ],
    fourthtext: [''],
    sources: [
      {
        name: 'World Animal Protection | Animal Protection Index',
        url: 'https://api.worldanimalprotection.org/',
      },
    ],
  },
  transparancy: {
    title: 'Transparens',
    issueTextParagraphs: [
      'Transparenspoäng visar andelen produktinformation som tillhandahålls av producenten. Till exempel, om mängd och ursprung anges för varje ingrediens blir transparenspoängen 100%. Om mängd och ursprung inte anges alls eller endast för ett par ingredienser blir poängen lägre.',
    ],
    howToThinkTextParagraphs: [],
    fourthtext: [''],
    sources: [
      {
        name: 'Amfori',
        url: 'https://www.amfori.org/en/solutions/social/amfori-bsci',
      },
    ],
  },
  childLabor: {
    title: 'Barnarbete',
    issueTextParagraphs: [
      'I världens fattigaste länder utför mer än vart fjärde barn arbete som är skadligt för deras hälsa och utveckling. International Labor Organization, ILO, definierar barnarbete som ”arbete som berövar barn (alla individer under 18 år) deras barndom, potential och värdighet, och som är skadligt för deras fysiska och/eller mentala utveckling”.',
    ],
    howToThinkTextParagraphs: [
      'När du väljer produkter med höga poäng, istället för låga, i den här parametern har produkten producerats i ett land med mindre risk för barnarbete. Värdet baseras på data från UNICEF och ILO:',
    ],
    fourthtext: [''],
  },
  animalWelfare: {
    title: 'Djurvälfärd',
    issueTextParagraphs: [
      'En stor del av våra livsmedel innehåller animaliska produkter från djur såsom grisar, kor, höns och får. Tyvärr utsätts djuren ofta för stort lidande under uppfödning och slakt. Det kan t.ex. handla om trånga burar, långa transporter och plågsamma slaktmetoder.',
    ],
    howToThinkTextParagraphs: [
      'Värdet beräknas utifrån Animal Protection Index som tas fram av organisationen World Animal Protection som varje år rankar 50 länder runtom i världen utifrån hur deras lagar och regler kring djurskydd ser ut. World Animal Protection är en global ideell organisation som arbetar för att stärka djurskyddet.',
      'När du väljer produkter med höga värden, istället för låga, i den här parametern kommer de animaliska ingredienserna från länder där djurskyddet är bättre.',
    ],
    fourthtext: [''],
  },
  workersRights: {
    title: 'Arbetsförhållanden',
    issueTextParagraphs: [
      'Jordbruk, fiske, avel och djurhållning – matproduktion är en global industri som sysselsätter en stor del av jordens befolkning. För många är arbetsförhållandena dåliga och krävande. Goda arbetsförhållanden innebär inte bara att arbetstagaren har en fysiskt säker arbetsmiljö det innefattar även skälig ersättning för rimliga arbetstider, rätten att organisera sig i fackförbund och anställningstrygghet.',
    ],
    howToThinkTextParagraphs: [
      'Värdet beräknas utifrån data från Amforis, som är en internationell medlemsorganisation för transparent och hållbar handel. Amfori publicerar regelbundet rapporter som beaktar Världsbankens indikatorer för styrning (eng. governance): Voice and Accountability, Political Stability and Absence of Violence/Terrorism, Government Effectiveness, Regulatory Quality, Rule of Law. I rapporten rankas länder utifrån hur deras lagar och regler kring arbetsförhållanden.',
      'När du väljer produkter med höga värden, istället för låga, i den här parametern har produkten producerats i länder där arbetsförhållandena är bättre.',
    ],
    fourthtext: [''],
  },
  equality: {
    title: 'Jämlikhet',
    issueTextParagraphs: [
      'I ett jämlikt samhälle är resurser och rättigheter tillgängliga på samma villkor för alla människor. Värdet för jämlikhet baseras på Gender Inequality Index (GII) som visar ojämlikhet mellan kvinnor och män i ett land. GII fokuserar på tre områden: reproduktiv hälsa, inflytande och arbetsmarknad.',
    ],
    howToThinkTextParagraphs: [''],
    fourthtext: [
      'När du väljer produkter med höga värden, istället för låga, i den här parametern har produkten producerats i ett land där jämlikheten är bättre.',
    ],
    sources: [
      {
        name: 'Gender Inequality Index | Human Development Reports',
        url: 'https://hdr.undp.org/data-center/thematic-composite-indices/gender-inequality-index#/indicies/GII',
      },
    ],
  },
  local_population: {
    title: 'Lokalbefolkning',
    issueTextParagraphs: [
      'En stor del av världens livsmedelssystem är beroende av produkter och råvaror från länder vars befolkning har ett dåligt skydd från rättssystemet när det gäller bland annat kriminalitet, våld och äganderätt till land. Parametern Lokalbefolkning ger ett mått på hur rättssäkert samhället är där produkten har producerats.',
    ],
    howToThinkTextParagraphs: [
      'Värdet beräknas utifrån data från Amforis, en internationell medlemsorganisation för transparent och hållbar handel där länder rankas med avseende på rättssäkerhet.',
      'När du väljer produkter med höga värden, istället för låga, i den här parametern har produkten producerats i ett land där rättssäkerheten är bättre.',
    ],
    fourthtext: '',
    sources: [
      {
        name: 'Amfori',
        url: 'https://www.amfori.org/en/solutions/social/amfori-bsci',
      },
    ],
  },
};

